<!--  确认弹框 -->
<template>
    <div>
        <veui-dialog
            :title="title"
            :open="true"
            :footless="true"
            :closable="isShowCloseIcon"
            ui="auto"
            overlay-class="add-error-dialog"
            @cancel="cancel"
        >
            <template v-if="!isDefaultTitle" #title>
                <img
                    v-if="icon"
                    class="icon"
                    :src="icon"
                />
                <span class="text">{{ title }}</span>
            </template>
            <div v-if="isDefaultContent && content" class="content">{{ content }}</div>
            <div v-else class="content">
                <slot></slot>
            </div>
            <div class="foot">
                <veui-button
                    v-if="isShowCancelBtn"
                    ui="strong"
                    class="cancel-btn"
                    @click="cancel"
                >{{ cancelBtn }}</veui-button>
                <veui-button
                    ui="primary"
                    class="confirm-btn"
                    @click="confirm"
                >{{ confirmBtn }}</veui-button>
            </div>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 确认弹框
 * @author dingzhenyue
 */
import {Dialog, Button} from 'veui';

export default {
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    props: {
        // dialog标题
        title: {
            'type': String,
            'default': '111',
            'required': true
        },
        // 确认按钮文案
        confirmBtn: {
            'type': String,
            'default': '确认',
            'required': false
        },
        // 取消按钮文案
        cancelBtn: {
            'type': String,
            'default': '取消',
            'required': false
        },
        // 内容文案
        content: {
            'type': String,
            'default': '',
            'required': false
        },
        // 标题中的icon
        icon: {
            'type': String,
            'default': '',
            'required': false
        },
        // 是否使用默认标题样式
        isDefaultTitle: {
            'type': Boolean,
            'default': false,
            'required': false
        },
        // 是否展示取消按钮，默认展示
        isShowCancelBtn: {
            'type': Boolean,
            'default': true,
            'required': false
        },
        // 是否使用默认内容样式
        isDefaultContent: {
            'type': Boolean,
            'default': true,
            'required': false
        },
        // 是否展示右上角的关闭按钮
        isShowCloseIcon: {
            'type': Boolean,
            'default': false,
            'required': false
        }
    },
    methods: {

        /**
         * 点击了确认按钮
         */

        confirm() {
            this.$emit('confirm');
        },

        /**
         * 点击了取消按钮
         */

        cancel() {
            this.$emit('cancel');
        }
    }
};
</script>

<style lang='less' scoped>
.add-error-dialog {
    .veui-dialog-content {
        box-shadow: 0 0 10px 0 rgb(196 196 196 / 50%);
        border-radius: 4px;
        width: 420px;
    }

    .veui-dialog-content-head-title {
        .icon {
            height: 18px;
            width: 18px;
            margin-right: 8px;
        }

        .text {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #000;
            line-height: 24px;
            font-weight: 500;
        }
    }

    .content {
        font-size: 14px;
        color: #000;
        line-height: 22px;
        margin-top: 24px;
    }

    .foot {
        text-align: center;
        margin-top: 33px;

        .confirm-btn,
        .cancel-btn {
            height: 40px;
            width: 80px;
            background: #3855d5;
            border-radius: 5px;
            color: #fff;
        }

        .confirm-btn {
            margin-left: 20px;
        }

        .veui-button[ui~="primary"]:hover {
            background-color: #06f;
        }
    }
}
</style>
